import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/pages/index/images/jump_btn.png';
import _imports_1 from '../images/media_index_item_btn.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9c6559d4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "media_index_box"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "News and Information", -1);
});

var _hoisted_3 = {
  class: "container gird_box"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "media_index_left_box_text"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
  key: 2,
  class: "media_index_source"
};
var _hoisted_9 = {
  class: "media_index_bottmo_time"
};
var _hoisted_10 = {
  class: "media_index_right_box"
};
var _hoisted_11 = {
  class: "media_index_right_item"
};
var _hoisted_12 = {
  class: "media_index_item_left"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  class: "media_index_text_box"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  key: 1,
  class: "media_index_source_left"
};
var _hoisted_17 = {
  class: "media_index_item_right"
};
var _hoisted_18 = {
  class: "media_index_item_time"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "bottmo_line"
  }, null, -1);
});

var _hoisted_20 = {
  class: "media_index_right_item"
};
var _hoisted_21 = {
  class: "media_index_item_left"
};
var _hoisted_22 = ["innerHTML"];
var _hoisted_23 = {
  class: "media_index_text_box"
};
var _hoisted_24 = ["innerHTML"];
var _hoisted_25 = {
  key: 1,
  class: "media_index_source_left"
};
var _hoisted_26 = {
  class: "media_index_item_right"
};
var _hoisted_27 = {
  class: "media_index_item_time"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "bottmo_line"
  }, null, -1);
});

var _hoisted_29 = {
  key: 0,
  class: "media_index_right_item"
};
var _hoisted_30 = {
  class: "media_index_item_left"
};
var _hoisted_31 = ["innerHTML"];
var _hoisted_32 = {
  class: "media_index_text_box"
};
var _hoisted_33 = ["innerHTML"];
var _hoisted_34 = {
  key: 1,
  class: "media_index_source_left"
};
var _hoisted_35 = {
  class: "media_index_item_right"
};
var _hoisted_36 = {
  class: "media_index_item_time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "media_index_left_box",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[0]);
    })
  }, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.reportsList[0].coverImg,
    class: "media_index_left_box_img"
  }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "en_media_index_left_title",
    innerHTML: $setup.reportsList[0].title
  }, null, 8, _hoisted_6)) : _createCommentVNode("", true), $setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "media_index_left_text",
    innerHTML: $setup.reportsList[0].summary
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("img", {
    src: _imports_0,
    class: "media_index_left_img",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[0]);
    })
  }), $setup.reportsList.length > 0 && $setup.reportsList[0].source != 'Tenacia' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Source: " + _toDisplayString($setup.reportsList[0].source), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString($setup.reportsList.length > 0 ? $setup.reportsList[0].publishDate : ''), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_title",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[1]);
    }),
    innerHTML: $setup.reportsList[1].title
  }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_text",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[1]);
    }),
    innerHTML: $setup.reportsList[1].summary
  }, null, 8, _hoisted_15)) : _createCommentVNode("", true), $setup.reportsList.length > 0 && $setup.reportsList[1].source != 'Tenacia' ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Source: " + _toDisplayString($setup.reportsList[1].source), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString($setup.reportsList.length > 0 ? $setup.reportsList[1].publishDate : ''), 1), _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "media_index_item_btn",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[1]);
    })
  })]), _hoisted_19])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_21, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_title",
    innerHTML: $setup.reportsList[2].title,
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[2]);
    })
  }, null, 8, _hoisted_22)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_text",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[2]);
    }),
    innerHTML: $setup.reportsList[2].summary
  }, null, 8, _hoisted_24)) : _createCommentVNode("", true), $setup.reportsList.length > 0 && $setup.reportsList[2].source != 'Tenacia' ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Source: " + _toDisplayString($setup.reportsList[2].source), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString($setup.reportsList.length > 0 ? $setup.reportsList[2].publishDate : ''), 1), _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "media_index_item_btn",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[2]);
    })
  })]), _hoisted_28])]), $setup.reportsList.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_30, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_title",
    innerHTML: $setup.reportsList[3].title,
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[3]);
    })
  }, null, 8, _hoisted_31)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [$setup.reportsList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "media_index_right_item_text",
    innerHTML: $setup.reportsList[3].summary,
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[3]);
    })
  }, null, 8, _hoisted_33)) : _createCommentVNode("", true), $setup.reportsList.length > 0 && $setup.reportsList[3].source != 'Tenacia' ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Source: " + _toDisplayString($setup.reportsList[3].source), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($setup.reportsList.length > 0 ? $setup.reportsList[3].publishDate : ''), 1), _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "media_index_item_btn",
    onClick: _cache[10] || (_cache[10] = function ($event) {
      return $setup.jumpMediaDetail($setup.reportsList[3]);
    })
  })])])])) : _createCommentVNode("", true)])])])]);
}